// extracted by mini-css-extract-plugin
export default {"tabletImg":"gF","desktopImg":"hF","mobileImg":"iF","backgroundImage":"jF","content":"kF","rtbLeft":"lF","rtbRight":"mF","imageContainer":"nF","rtbBox":"oF","line":"pF","rtbLeftMobile":"qF","rtbDesktop":"rF"};
    if(module.hot) {
      // 1713211520752
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  